import type { TypeMouseConfig } from './types';

// ----------------------------------------------------------------------------

function demo(config: TypeMouseConfig = {}): () => void {
    const onMouseDown = function (this: Document, evt: MouseEvent): void {
        if (typeof config.fnAction === 'function') {
            config.fnAction.call(this, evt);
            return;
        }

        console.log(evt);
    };

    document.addEventListener('mousedown', onMouseDown);

    return function cleanup(): void {
        document.removeEventListener('mousedown', onMouseDown);
    };
}

// ----------------------------------------------------------------------------

export default demo;
